import Vue from 'vue'
import define from '../systemAdminDefineModules/systemAdminDefineMutation.js'
// master-action
const URL = process.env.API_MASTER_URL
const header = define.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  changeUnauthorizedFlag(store, payload) {
    store.commit('changeUnauthorizedFlag')
  },
  async loginMasterUser(store, payload) {
    const config = {
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          userId: payload.userId,
          password: payload.password
        }
      ]
    }
    var response = await Vue.http.post(URL + '/v2/master/login', data, config)
    // 成功
    // 追加後の処理
    return response
  },
  async logoutCareRings(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [{}]
    }
    await Vue.http.post(URL + '/v2/master/logout', data, config)
    // 成功
  },
  async checkMasterUserPassword(store, previousPassword) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          userId: define.state.header.userId,
          previousPassword: previousPassword
        }
      ]
    }
    await Vue.http.post(URL + '/v2/master/masteruser/confirm', data, config)
    // 成功
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/sessionModules/actions.js